module.exports = __webpack_public_path__ + "static/img/index-bg.a45caa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ceshi/index-bg.png
// module id = qYA1
// module chunks = 156